import { nanoid } from 'nanoid';
import { nanoid as nsNanoid } from 'nanoid/non-secure';

/**
 * Web workers don't have access to a secure random generator e.g. `crypto.getRandomValues`
 * This is a safe helper/workaround for generating unique IDs in web workers
 */
const nonSecureNanoid = nsNanoid;

export { nanoid, nonSecureNanoid };
